import {Camera, Mesh, NearestFilter, PlaneGeometry, RepeatWrapping, ShaderMaterial, WebGLRenderTarget} from 'three'

import {getRenderer} from '../_commonObjects'
import bayer from '../_shaders/dithering/bayer.frag.ts'

export default class BayerTexture {
  // enable repeat
  fbo: WebGLRenderTarget = new WebGLRenderTarget(8, 8, {
    minFilter: NearestFilter,
    magFilter: NearestFilter,
    wrapS: RepeatWrapping,
    wrapT: RepeatWrapping,
  })
  plane: Mesh
  constructor() {
    this.plane = new Mesh(
      new PlaneGeometry(2, 2),
      new ShaderMaterial({
        vertexShader: `
          varying vec2 vUv;
          void main() {
            vUv = uv;
            gl_Position = vec4(position, 1.0);
          }
        `,
        fragmentShader: `${bayer}
          varying vec2 vUv;
          void main() {
            float dithering = Bayer64(gl_FragCoord.xy);
            gl_FragColor = vec4(vec3(dithering), 1.0);
          }
        `,
      }),
    )
  }

  renderOnce() {
    const renderer = getRenderer()
    if (!renderer) return
    renderer.setRenderTarget(this.fbo)
    renderer.render(this.plane, new Camera())
  }
}
